const VALID_PART_TYPES = new Set(['NEW', 'AFTERMARKET', 'USED']);

export function resolveEffectivePartType(product) {
  const explicit = String(product?.partType || '').trim().toUpperCase();
  if (VALID_PART_TYPES.has(explicit)) return explicit;
  return 'AFTERMARKET';
}

export function getDealStructuredAttributeGaps(product) {
  const missing = [];
  if (!String(product?.brand || '').trim()) missing.push('Brand');
  if (!VALID_PART_TYPES.has(resolveEffectivePartType(product))) {
    missing.push('Part Type');
  }
  const specs = product?.specs;
  const hasSpecs =
    specs && typeof specs === 'object' && !Array.isArray(specs) && Object.keys(specs).length > 0;
  if (!hasSpecs) {
    missing.push('Specification (sections 1, 3, and 4 on the product form)');
  }
  return missing;
}

export function isProductDealReady(product, { exemptStructured = false } = {}) {
  if (exemptStructured) return true;
  return getDealStructuredAttributeGaps(product).length === 0;
}

export function formatDealEligibilityError(product, dealCategory = '') {
  const missing = getDealStructuredAttributeGaps(product);
  if (!missing.length) return '';
  if (String(dealCategory).toLowerCase() === 'brand') {
    return `This product cannot be used for a brand campaign yet. Missing: ${missing.join(', ')}. Update the listing under Vendor → Products, then try again.`;
  }
  return `This product cannot be used for a deal yet. Missing: ${missing.join(', ')}. Edit the product (Vendor → Products), fill sections 1, 3, and 4, then save again.`;
}

export function dealCategoryRequiresStructuredAttributes(category) {
  const c = String(category || '').toLowerCase();
  return !['seller_own', 'clearance', 'garage_service', 'coupon'].includes(c);
}
